import type { Tag } from '@core/tags/types.js';

import { posthogActorSend } from './posthog-machine.js';

/**
 * PostHog tag — thin translator from c15t consent lifecycle events + `track()`
 * dispatch into machine events. All the actual lifecycle (init, identify,
 * opt-in/out, queue, capture) lives in [`posthog-machine.ts`](./posthog-machine.ts).
 *
 * - `onSet`: fires on hydration + every save. Drives the initial
 *   `idle → activeNoId` transition when `measurement` is granted.
 * - `onChange`: fires on explicit transitions. Drives grant/revoke
 *   between `activeNoId` ↔ `dormant`.
 * - `onTrack`: forwards every validated event into the machine; the machine
 *   queues, sends, or drops based on its current state.
 */
export const posthogTag: Tag = {
  onSet: ({ preferences }) => {
    if (preferences.measurement) posthogActorSend({ type: 'CONSENT_GRANTED' });
  },
  onChange: ({ allowedCategories, previousAllowedCategories }) => {
    const was = previousAllowedCategories.includes('measurement');
    const is = allowedCategories.includes('measurement');
    if (is && !was) posthogActorSend({ type: 'CONSENT_GRANTED' });
    else if (!is && was) posthogActorSend({ type: 'CONSENT_REVOKED' });
  },
  onTrack: (event, data) => {
    posthogActorSend({ type: 'TRACK', event, data });
  },
};
